import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

export const setIsLoaded = mutatorAction('setIsLoaded', (isLoaded: boolean = true) => {
    getStore().isLoaded = isLoaded;
});
